import * as type from './types'



export function savedArchive(archive) {
    return {
        type : type.SAVED_ARCHIVE,
        payload : archive,
        txn : 'success',
        diff : true
    };
}


export function editArchive(archive) {
    return {
        type : type.EDIT_ARCHIVE,
        payload : archive,
        txn : 'initiated',
    };
}


export function fetchArchive() {
    return {
        type : type.FETCH_ARCHIVE,
    };
}


export function fetchedArchive(archive) {
    return {
        type : type.FETCHED_ARCHIVE,
        payload : archive
    };
}

export function fetchDownloadData(archive,setIsLoading) {
    return {
        type : type.FETCH_DOWNLOAD_ARCHIVE,
        payload : archive,
        payload1:setIsLoading
    };
}


export function fetchedDownloadData(archive) {
    return {
        type : type.FETCHED_DOWNLOAD_ARCHIVE,
        payload : archive
    };
}

export function saveArchiveEditedRes(archive) {
    return {
        type : type.SAVED_ARCHIVE_RES,
        payload : archive
    };
}

export function deleteArchive(archive) {
    return {
        type : type.DELETE_ARCHIVE,
        payload: archive
    };
}


export function deletedArchive(msg) {
    return {
        type : type.DELETED_ARCHIVE,
        payload : msg
    };
}


export function setNotifyDone(props) {
    return {
        type : type.NOTIFICATION_DONE_ARCHIVE,
        payload: props
    };
}

